import React from 'react';
import { useTranslation } from 'react-i18next';

function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <div className='container text-center'>
      <div className="d-flex justify-content-center align-items-center" style={{ height: '80vh'}}>
        <h1 className='text-white'>{t('error.notFound')}</h1>
      </div>
    </div>
  );
}

export default NotFoundPage;